import { Route } from '@angular/router';
import { SignupComponent } from './index';

export const SignupRoutes: Route[] = [
    {
      path: 'signuptopsec',
      component: SignupComponent
    }
];



// WEBPACK FOOTER //
// ./src/app/signup/signup.routes.ts